// components/CopyButton.js
"use client"

import React from 'react';
import toast from 'react-hot-toast';
const CopyButton = ({children}) => {
  const copyToClipboard = () => {
    const url = window.location.href;
    navigator.clipboard.writeText(url)
      .then(() => {
        // console.log('URL copied to clipboard');
        toast.success('Link Copied!')
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <span onClick={copyToClipboard}>
      {children}
    </span>
  );
};

export default CopyButton;
